import React, { useEffect } from 'react';
import { CustomHelperText, CustomSlider, SliderBox, SliderWrapper, Wrapper, } from './RangeSliderComponent.Styles';
export var RangeSliderComponent = function (props) {
    var _a = React.useState([1, 25]), value = _a[0], setValue = _a[1];
    useEffect(function () {
        setValue(props.field.value[1] <= props.range[1] &&
            props.field.value[0] >= props.range[0]
            ? props.field.value
            : [props.range[0], props.range[1]]);
    }, [props.field.value]);
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    var handleCommittedChange = function (event, newValue) {
        props.form.setFieldValue(props.field.name, newValue);
    };
    return (React.createElement(Wrapper, { half: props.half },
        React.createElement(CustomHelperText, null, props.label),
        React.createElement(SliderWrapper, null,
            React.createElement(SliderBox, null,
                React.createElement(CustomSlider, { value: value, min: props.range[0], max: props.range[1], onChange: handleChange, onChangeCommitted: handleCommittedChange, 
                    // getAriaLabel={1}
                    valueLabelDisplay: 'on' })))));
};
RangeSliderComponent.defaultProps = {};
//# sourceMappingURL=RangeSliderComponent.js.map